import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { viewSettings } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DOMPurify from "dompurify";

// ReadMoreText component
function ReadMoreText({ content }: { content: string }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const wordCount = content?.split(/\s+/).length || 0;
  const shouldTruncate = wordCount > 100;

  const toggle = () => setIsExpanded(!isExpanded);

  const displayedContent = useMemo(() => {
    if (!shouldTruncate || isExpanded) {
      return DOMPurify.sanitize(content);
    }
    const truncated = content.split(/\s+/).slice(0, 100).join(" ") + "...";
    return DOMPurify.sanitize(truncated);
  }, [content, isExpanded, shouldTruncate]);

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: displayedContent,
        }}
      />
      {shouldTruncate && (
        <button
          className="btn btn-link btn-sm mt-2 p-0"
          onClick={toggle}
          style={{ textDecoration: "underline" }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}
    </>
  );
}

export function ViewSettings() {
  const { id } = useParams();
  const { userProfile } = useProfile();
  const history = useNavigate();
  const [Settings, setSettings] = useState<any>({});

  useEffect(() => {
    viewSettings(id).then((res: any) => {
      setSettings(res);
    });
  }, [id]);

  document.title = "Paal Dappa | Admin panel";

  const type: Record<number, string> = {
    1: "User App",
    2: "Driver App",
  };

  const settingsFields = [
    { label: "About", value: Settings?.about },
    { label: "Terms And Condition", value: Settings?.terms_and_condition },
    { label: "Privacy Policy", value: Settings?.privacy_policy },
    { label: "Cancellation Policy", value: Settings?.cancellation_policy },
  ];

  function goBack() {
    history(-1);
  }

  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer closeButton={false} limit={1} />
        <BreadCrumb title="View Settings" pageTitle="Settings" />

        <Row>
          <Col>
            <button
              onClick={goBack}
              className="btn btn-primary px-2 text-center mb-3"
            >
              <i className="ri ri-reply-line fs-6 me-2"></i> Go Back
            </button>
          </Col>
        </Row>

        <Card>
          <CardHeader>
            <Row className="g-4 align-items-center">
              <div className="col-sm">
                <h5 className="card-title mb-0">Settings Details</h5>
              </div>
              <div className="col-sm-auto">
                <Link to={`/settings/edit/${id}`}>
                  <i className="ri-pencil-fill align-bottom me-1"></i> Edit
                </Link>
              </div>
            </Row>
          </CardHeader>

          <CardBody>
            <Row className="mb-3">
              <Col className="col-4 fw-bold">Setting Type</Col>
              <Col className="col-3">
                {type[Settings?.settings_type] || "Unknown"}
              </Col>
            </Row>

            <div className="table-responsive">
              <table className="table table-bordered">
               
                <tbody>
                  {settingsFields.map((field, index) => (
                    <tr key={index}>
                      <td className="fw-bold">{field.label}</td>
                      <td>
                        <ReadMoreText content={field.value || ""} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}
